//#region import
import React, { Fragment, createContext, useEffect, useMemo, useState } from 'react';
import { Grid } from '@mui/material';
import { APIStatusCode, EnumLogHistoryMode, EnumProjectStatusID, EnumRegisterTimelineType, EnumSaveModeProject, I18NextNs } from 'enum/enum';
import Tabs, { TabContent, TabItem, TabPanel } from 'components/Input/Tab';
import { GetMenuPermission } from 'utilities/SystemFunction';
import { FnAxios, FnDialog } from 'utilities/utilities';
import ProjectCheckRecordNormal from './ProjectCheckRecordNormal';
import ProjectCheckRecordFastTrack from './ProjectCheckRecordFastTrack';
//#endregion

const ProjectCheckRecordList = () => { //ตรวจสอบ/บันทึกผล (ปกติ || เร่งด่วน)
    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();

    //#region useState
    // const sBackgroundTab = "rgb(17 56 120)";
    // const sBackgroundTabActive = "linear-gradient(rgb(77 110 197) 33%, rgb(101 158 221 / 57%) 71%, rgb(184 209 255 / 68%) 87%, rgb(255, 255, 255) 100%)";

    const sBackgroundTab = "rgb(154 6 6)";
    const sBackgroundTabActive = "linear-gradient(rgb(188, 123, 41) 33%, rgb(217, 180, 134) 71%, rgb(233, 211, 184) 87%, rgb(255, 255, 255) 100%)";

    const [isPermission, setPermission] = useState<boolean>(true); //false // Permission true = Edit | false = View, Disabled
    const [sTabID, setsTabID] = useState("Tab1");
    //#endregion   

    useEffect(() => {
        GetMenuPermission(AxiosFn, setPermission, DialogFn);
    }, []);

    return (
        <Grid item xs={12} md={12} container spacing={1} style={{ padding: '1%', paddingBottom: '1%', }}>
            <Tabs id={"TabsCheckRecord"} defaultTab={sTabID} onTabChange={(e) => { setsTabID(e); }}>
                <TabItem 
                    key={"Tab1"} 
                    id={"Tab1"} 
                    sBackgroundTab={sBackgroundTab} 
                    sBackgroundTabActive={sBackgroundTabActive}
                >แบบปกติ</TabItem>
                <TabItem 
                    key={"Tab2"} 
                    id={"Tab2"}
                    sBackgroundTab={sBackgroundTab} 
                    sBackgroundTabActive={sBackgroundTabActive}
                >แบบเร่งด่วน</TabItem>
                <TabContent id={"TabContentKth1"}>
                    <TabPanel id="Tab1">
                        {/* แบบปกติ */}
                        <ProjectCheckRecordNormal /> 
                    </TabPanel>
                    <TabPanel id="Tab2">
                        {/* แบบเร่งด่วน */}
                        <ProjectCheckRecordFastTrack />
                    </TabPanel>
                </TabContent>
            </Tabs>
        </Grid>
    )
}
export default ProjectCheckRecordList;